import { DataState } from '../models/config-strip-state.models';

export const getScales = (data: DataState) => {
  let yScale;
  let xScale;
  const defaultScale = data.scaleSets?.default;
  const scale = data.scaleSets?.scales?.[defaultScale as string];
  if (scale) {
    [xScale, yScale] = Object.keys(scale);
  }
  return [xScale ?? 'size', yScale ?? 'width'];
};
